const BRAZIL_TIMEZONE = 'America/Sao_Paulo'
// Backend envia LocalDateTime sem timezone, 3h atrás do Brasil (UTC-6 vs UTC-3).
const BACKEND_IMPLICIT_OFFSET = '-06:00'

const hasExplicitTimezone = (raw: string) => /([zZ]|[+\-]\d{2}:\d{2})$/.test(raw)

const parseBackendDate = (value: string | null | undefined): Date | null => {
  if (!value) return null
  const raw = String(value).trim()
  if (!raw) return null
  const iso = hasExplicitTimezone(raw) ? raw : `${raw}${BACKEND_IMPLICIT_OFFSET}`
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return null
  return d
}

export const formatBrazilDateTimeFromBackend = (value: string | null | undefined) => {
  const d = parseBackendDate(value)
  if (!d) return value ? String(value) : '—'
  return d.toLocaleString('pt-BR', { timeZone: BRAZIL_TIMEZONE })
}

export const formatBrazilDateFromBackend = (value: string | null | undefined) => {
  const d = parseBackendDate(value)
  if (!d) return value ? String(value) : '—'
  return d.toLocaleDateString('pt-BR', { timeZone: BRAZIL_TIMEZONE })
}

